export function imageChange() {

	jQuery(function ($) {
		$('#is-button-eco').hover(
			//ホバーされた時
			function () {
				//画像を変更
				$('.p-houseImageWrap__image').addClass('is-change-eco');
				//ボタン画像を変更
				$('#is-button-eco a').addClass('is-link');
				//class外す
				$('#is-button-sun a').removeClass('is-link');
				$('#is-button-battery a').removeClass('is-link');
				$('#is-button-smart a').removeClass('is-link');
				$('#is-button-reform a').removeClass('is-link');
				$('#is-button-car a').removeClass('is-link');
				setTimeout(function () {
					$('#is-button-eco a').addClass('is-link-move');
				}, 1000);
			}, function () {
				//ホバーから外れた時
				$('.p-houseImageWrap__image').removeClass('is-change-eco');
				$('#is-button-sun a').removeClass('is-link-move');
				$('#is-button-battery a').removeClass('is-link-move');
				$('#is-button-smart a').removeClass('is-link-move');
				$('#is-button-reform a').removeClass('is-link-move');
				$('#is-button-car a').removeClass('is-link-move');
			}
		)
		$('#is-button-sun').hover(
			//ホバーされた時
			function () {
				$('.p-houseImageWrap__image').addClass('is-button-sun');
				//ボタン画像を変更
				$('#is-button-sun a').addClass('is-link');

				//class外す
				$('#is-button-eco a').removeClass('is-link');
				// $('#is-button-sun a').removeClass('is-link');
				$('#is-button-battery a').removeClass('is-link');
				$('#is-button-smart a').removeClass('is-link');
				$('#is-button-reform a').removeClass('is-link');
				$('#is-button-car a').removeClass('is-link');
				setTimeout(function () {
					$('#is-button-sun a').addClass('is-link-move');
				}, 1000);
			}, function () {
				//ホバーから外れた時
				$('.p-houseImageWrap__image').removeClass('is-button-sun');
				$('#is-button-eco a').removeClass('is-link-move');
				// $('#is-button-sun a').removeClass('is-link-move');
				$('#is-button-battery a').removeClass('is-link-move');
				$('#is-button-smart a').removeClass('is-link-move');
				$('#is-button-reform a').removeClass('is-link-move');
				$('#is-button-car a').removeClass('is-link-move');
			}
		)
		$('#is-button-battery').hover(
			//ホバーされた時
			function () {
				$('.p-houseImageWrap__image').addClass('is-button-battery');
				//ボタン画像を変更
				$('#is-button-battery a').addClass('is-link');

				//class外す
				$('#is-button-eco a').removeClass('is-link');
				$('#is-button-sun a').removeClass('is-link');
				// $('#is-button-battery a').removeClass('is-link');
				$('#is-button-smart a').removeClass('is-link');
				$('#is-button-reform a').removeClass('is-link');
				$('#is-button-car a').removeClass('is-link');
				setTimeout(function () {
					$('#is-button-battery a').addClass('is-link-move');
				}, 1000);
			}, function () {
				//ホバーから外れた時
				$('.p-houseImageWrap__image').removeClass('is-button-battery');
				$('#is-button-eco a').removeClass('is-link-move');
				$('#is-button-sun a').removeClass('is-link-move');
				// $('#is-button-battery a').removeClass('is-link-move');
				$('#is-button-smart a').removeClass('is-link-move');
				$('#is-button-reform a').removeClass('is-link-move');
				$('#is-button-car a').removeClass('is-link-move');
			}
		)
		$('#is-button-smart').hover(
			//ホバーされた時
			function () {
				$('.p-houseImageWrap__image').addClass('is-button-smart');
				//ボタン画像を変更
				$('#is-button-smart a').addClass('is-link');

				//class外す
				$('#is-button-eco a').removeClass('is-link');
				$('#is-button-sun a').removeClass('is-link');
				$('#is-button-battery a').removeClass('is-link');
				// $('#is-button-smart a').addClass('is-link');
				$('#is-button-reform a').removeClass('is-link');
				$('#is-button-car a').removeClass('is-link');
				setTimeout(function () {
					$('#is-button-smart a').addClass('is-link-move');
				}, 1000);
			}, function () {
				//ホバーから外れた時
				$('.p-houseImageWrap__image').removeClass('is-button-smart');
				$('#is-button-eco a').removeClass('is-link-move');
				$('#is-button-sun a').removeClass('is-link-move');
				$('#is-button-battery a').removeClass('is-link-move');
				// $('#is-button-smart a').addClass(
				$('#is-button-reform a').removeClass('is-link-move');
				$('#is-button-car a').removeClass('is-link-move');
			}
		)
		$('#is-button-reform').hover(
			//ホバーされた時
			function () {
				$('.p-houseImageWrap__image').addClass('is-button-reform');
				//ボタン画像を変更
				$('#is-button-reform a').addClass('is-link');

				//class外す
				$('#is-button-eco a').removeClass('is-link');
				$('#is-button-sun a').removeClass('is-link');
				$('#is-button-battery a').removeClass('is-link');
				$('#is-button-smart a').removeClass('is-link');
				$('#is-button-car a').removeClass('is-link');
				setTimeout(function () {
					$('#is-button-reform a').addClass('is-link-move');
				}, 1000);
			}, function () {
				//ホバーから外れた時
				$('.p-houseImageWrap__image').removeClass('is-button-reform');
				$('#is-button-eco a').removeClass('is-link-move');
				$('#is-button-sun a').removeClass('is-link-move');
				$('#is-button-battery a').removeClass('is-link-move');
				$('#is-button-smart a').removeClass('is-link-move');
				$('#is-button-car a').removeClass('is-link-move');
			}
		)
		$('#is-button-car').hover(
			//ホバーされた時
			function () {
				$('.p-houseImageWrap__image').addClass('is-button-car');
				//ボタン画像を変更
				$('#is-button-car a').addClass('is-link');

				//class外す
				$('#is-button-eco a').removeClass('is-link');
				$('#is-button-sun a').removeClass('is-link');
				$('#is-button-battery a').removeClass('is-link');
				$('#is-button-smart a').removeClass('is-link');
				$('#is-button-reform a').removeClass('is-link');
				// $('#is-button-car a').removeClass('is-link');
				setTimeout(function () {
					$('#is-button-car a').addClass('is-link-move');
				}, 1000);
			}, function () {
				//ホバーから外れた時
				$('.p-houseImageWrap__image').removeClass('is-button-car');
				$('#is-button-eco a').removeClass('is-link-move');
				$('#is-button-sun a').removeClass('is-link-move');
				$('#is-button-battery a').removeClass('is-link-move');
				$('#is-button-smart a').removeClass('is-link-move');
				$('#is-button-reform a').removeClass('is-link-move');
			}
		)
	});
}

